var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagVietnam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2705C24.8366 32.2705 32 25.1071 32 16.2705C32 7.43395 24.8366 0.270508 16 0.270508C7.16344 0.270508 0 7.43395 0 16.2705C0 25.1071 7.16344 32.2705 16 32.2705Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.61816L17.7267 13.9325H23.3145L18.7939 17.2169L20.5206 22.5312L16 19.2468L11.4794 22.5312L13.2061 17.2169L8.68549 13.9325H14.2732L16 8.61816Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.270508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagVietnam);
export default __webpack_public_path__ + "static/media/flag_vietnam.d27c39480725b704df28c9b433115568.svg";
export { ForwardRef as ReactComponent };